import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

function usePageTitle() {
  const location = useLocation();

  return useMemo(() => {
    const functions = JSON.parse(localStorage.getItem('functionsData') || '[]');

    const currentPath = location.pathname.toLowerCase();

    if (currentPath === '/workitem/add') {
      sessionStorage.setItem('_fni', 1);
      sessionStorage.setItem('functionality', 'Create Leads');
      return 'Create Leads';
    }

     if (currentPath === '/workitem/edit') {
      sessionStorage.setItem('_fni', 1);
      sessionStorage.setItem('functionality', 'Create Leads');
      return 'Edit Leads';
    }

    const match = functions.find((f) => f.launch?.toLowerCase() === currentPath);
    sessionStorage.setItem('_fni', match?.id || 1);
    sessionStorage.setItem('functionality', match?.functionality || 'Report');

    return match?.functionality || '';
  }, [location.pathname]);
}

export default function HeaderPageTitle() {
  const title = usePageTitle();

  if (!title) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        left: '45%',
        transform: 'translateX(-50%)',
        pointerEvents: 'none'
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          fontSize: '1.05rem',
          letterSpacing: '0.02em',
          color: 'text.primary',
          lineHeight: 1.2
        }}
        noWrap
      >
        {title}
      </Typography>
    </Box>
  );
}
